import React, { useState } from "react";
import "../../../src/assets/css/home.css";
import { useNavigate } from "react-router-dom";

const QualitySection = () => {
    const navigate = useNavigate();

    return (
        <>
            <section
                className="quality-section container-fluid py-5 mt-5 d-flex flex-wrap justify-content-around align-items-center"
                style={{ gap: "2rem" }}
            >
                {/* Right Image */}
                <div className="text-center" data-aos="slide-right">
                    <img
                        src="/assets/images/Home/quality1.png"
                        alt="PC Frame"
                        className="img-fluid shadow"
                        style={{ maxHeight: "500px", objectFit: "cover" }}
                    />
                </div>

                {/* Left Content */}
                <div className="quality-text text-center d-flex flex-column justify-content-around" data-aos="slide-left">
                    <h2 className="title text-primary fw-bold">
                        Quality that you can <br /> stand by.
                    </h2>

                    <div className="button-group">
                        <span id="cta-btn-wrapper">
                            <button className="primary-button-cta" onClick={() => navigate("/about-us")}>
                                Know More
                            </button>
                        </span>
                    </div>
                </div>
            </section>
        </>
    );
}

export default QualitySection;
